import { Constants } from './'

export const openSellersDrawer = payload => ({
  type: Constants.UI_SELLERS_DRAWER_OPEN
})

export const closeSellersDrawer = () => ({
  type: Constants.UI_SELLERS_DRAWER_CLOSE
})

export const openStockInfoDrawer = payload => ({
  type: Constants.UI_STOCKINFO_DRAWER_OPEN
})

export const closeStockInfoDrawer = () => ({
  type: Constants.UI_STOCKINFO_DRAWER_CLOSE
})

export const toggleSellersDrawer = () => ({
  type: Constants.UI_SELLERS_DRAWER_TOGGLE
})
